<template>
  <div v-cloak v-if="template" class="item-common pt-10 pb-5 px-7">
    <div class="header">
      <h1 class="title">
        {{ $t(template.licenseTitle) }}
        <span v-if="itemMaxLength" class="max-length-guide">
          {{ $t('최대 입력 가능 갯수 : ') }} {{ $t(itemMaxLength) }}</span
        >
      </h1>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideLicense"></p>
    </div>
    <div class="body">
      <v-form ref="saveForm" v-if="!isReadonly">
        <v-row v-if="obj">
          <v-col cols="12" class="col-md-11">
            <v-row>
              <v-col cols="12" :class="collength">
                <CollectionAutoComplete
                  v-model="obj.licenseName"
                  :directInput="itemDirectInput('licenseName')"
                  :rules="[
                    rules.required('licenseName', true),
                    rules.maxlength('licenseName'),
                    licenseRule.duplicated(licenses, -1),
                  ]"
                  itemKey="license"
                  :label="itemLabel('licenseName')"
                  :readonly="isReadonly"
                  @change:item="item => autocomset(-1, item)"
                />
              </v-col>
              <v-col cols="12" :class="[collength, colclass]">
                <i-text-field
                  v-maxlength="'license_org'"
                  v-model="obj.licenseOrg"
                  :label="itemLabel('licenseOrg')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('licenseOrg', true),
                    rules.maxlength('licenseOrg'),
                  ]"
                  :class="[zeroRoundedClass]"
                ></i-text-field>
              </v-col>
              <v-col
                cols="12"
                v-if="license === 'B'"
                :class="[collength, colclass]"
              >
                <i-text-field
                  v-maxlength="'license_number'"
                  :label="itemLabel('licenseNumber')"
                  v-model="obj.licenseNumber"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[
                    rules.required('licenseNumber', true),
                    rules.maxlength('licenseNumber'),
                  ]"
                  :class="[zeroRoundedClass]"
                ></i-text-field>
              </v-col>
              <v-col cols="12" :class="[collength, colclass]">
                <CommonDatePicker
                  :readonly="isReadonly"
                  :label="itemLabel('licenseDate')"
                  :rules="[rules.required('licenseDate', true)]"
                  v-model="obj.licenseDate"
                  :type="licenseDateFormat === 'YYYY.MM' ? 'month' : 'date'"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            class="col-md-1 pl-md-3 mb-8 mb-md-0"
            :class="colclass"
          >
            <i-btn elevation="0" color="primary" block @click="add">저장</i-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-alert v-if="submitErrorAlert" dense outlined type="error">
        {{ submitErrorMessage }}
      </v-alert>
      <v-divider v-if="!isReadonly"></v-divider>
      <v-form ref="updateForm">
        <v-row
          v-for="(item, i) in licenses"
          :key="'licenseRow' + i"
          class="mt-4"
        >
          <v-col cols="12" :class="{ 'col-md-11': !isReadonly }">
            <v-row>
              <v-col cols="12" :class="collength">
                <i-text-field
                  v-model="item.licenseName"
                  :label="itemLabel('licenseName')"
                  outlined
                  v-maxlength="'license_name'"
                  dense
                  hide-details="auto"
                  :rules="
                    isReadonly
                      ? []
                      : [
                          rules.required('licenseName'),
                          licenseRule.duplicated(licenses, i),
                        ]
                  "
                  :class="[leftRoundedClass]"
                  readonly
                ></i-text-field>
              </v-col>
              <v-col cols="12" :class="[collength, colclass]">
                <i-text-field
                  v-maxlength="'license_org'"
                  v-model="item.licenseOrg"
                  :label="itemLabel('licenseOrg')"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="
                    isReadonly
                      ? []
                      : [
                          rules.required('licenseOrg'),
                          rules.maxlength('licenseOrg'),
                        ]
                  "
                  @blur="save(i)"
                  :class="[zeroRoundedClass]"
                  :readonly="isReadonly"
                ></i-text-field>
              </v-col>
              <v-col
                cols="12"
                v-if="license === 'B'"
                :class="[collength, colclass]"
              >
                <i-text-field
                  v-maxlength="'license_number'"
                  :label="itemLabel('licenseNumber')"
                  v-model="item.licenseNumber"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="
                    isReadonly
                      ? []
                      : [
                          rules.required('licenseNumber'),
                          rules.maxlength('licenseNumber'),
                        ]
                  "
                  @blur="save(i)"
                  :class="[zeroRoundedClass]"
                  :readonly="isReadonly"
                ></i-text-field>
              </v-col>
              <v-col cols="12" :class="[collength, colclass]">
                <CommonDatePicker
                  :readonly="isReadonly"
                  :label="itemLabel('licenseDate')"
                  :rules="[rules.required('licenseDate')]"
                  @change="save(i)"
                  v-model="item.licenseDate"
                  :type="licenseDateFormat === 'YYYY.MM' ? 'month' : 'date'"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            class="col-md-1 pl-md-3 mb-6 mb-md-0"
            :class="colclass"
            v-if="!isReadonly"
          >
            <i-btn
              elevation="0"
              color="normal"
              block
              outlined
              @click="remove(i)"
              >삭제</i-btn
            >
          </v-col>
        </v-row>
      </v-form>
      <template v-if="licenseMoreQuestionUseYn == 'Y'">
        <i-textarea
          class="mt-2"
          :readonly="isReadonly"
          dense
          ref="moreLicense"
          @blur="saveMoreLicense"
          @keydown.enter="saveMoreLicense"
          persistent-hint
          outlined
          hide-details="auto"
          :label="
            (template.opts.licenseMoreQuestions.oRequireYn == 'Y' ? '*' : '') +
              template.opts.licenseMoreQuestions.oGuide
          "
          v-model="moreQuestions"
          :rules="[
            rules.minlength('licenseMoreQuestions'),
            rules.required('licenseMoreQuestions'),
            rules.maxLength('licenseMoreQuestions'),
          ]"
          :counter="opts.licenseMoreQuestions.oMaxLength"
        >
        </i-textarea>
      </template>
    </div>
  </div>
</template>

<script>
import { DialogMixin } from '@/mixin/dialog.js';
import { mdiCalendarBlank } from '@mdi/js';
import CommonDatePicker from '@/components/common/CommonDatePicker.vue';

import { snack } from '@/plugins/dialog/api';
import CollectionAutoComplete from '@/components/common/CollectionAutoComplete.vue';
import { API } from '@/api/network';

export default {
  props: {
    applNo: { Type: String },
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    dynamicScreenTagClass: { type: Object },
    leftRoundedClass: { type: Object },
    rightRoundedClass: { type: Object },
    itemArray: {
      type: Function,
      default: () => {},
    },
    itemLabel: {
      type: Function,
      default: () => {},
    },
    itemDirectInput: {
      type: Function,
      default: () => {},
    },

    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  components: {
    CommonDatePicker,
    CollectionAutoComplete,
  },
  mounted() {
    this.setting();
  },
  computed: {
    itemMaxLength() {
      return +this.opts?.license?.oMaxLength || 0;
    },
    canAdd() {
      return (
        !this.opts?.license?.oMaxLength ||
        this.opts.license?.oMaxLength > this.licenses.length
      );
    },
    collength: function() {
      return {
        'col-md-4': this.license === 'A',
        'col-md-3': this.license === 'B',
      };
    },
    zeroRoundedClass: function() {
      return {
        'rounded-0':
          this.$vuetify.breakpoint.name != 'sm' &&
          this.$vuetify.breakpoint.name != 'xs',
      };
    },
    colclass: function() {
      return {
        'mt-2':
          this.$vuetify.breakpoint.name == 'sm' ||
          this.$vuetify.breakpoint.name == 'xs',
      };
    },
  },
  mixins: [DialogMixin],
  data: () => ({
    moreQuestions: '',
    licenseMoreQuestionUseYn: 'N',
    mdiCalendarBlank,
    obj: null,
    license: '',
    licenseDateFormat: '',
    licenses: [],
    itemSeq: 1,
    saveAlert: false,
    deleteAlert: false,
    submitErrorAlert: false,
    submitErrorMessage: '',
    isSetWord: false,
    licenseRule: {
      duplicated(items, idx) {
        var names = [];
        if (items && Array.isArray(items)) {
          for (var i = 0; i < items.length; i++) {
            if (i != idx) {
              var item = items[i];
              names.push(item.licenseName);
            }
          }
        }
        return v =>
          !v || (v && names.indexOf(v) < 0) || '이미 등록된 정보입니다.';
      },
    },
  }),
  watch: {
    saveAlert: function() {
      if (this.saveAlert) {
        setTimeout(() => {
          this.saveAlert = false;
        }, 2000);
      }
    },
    deleteAlert: function() {
      if (this.deleteAlert) {
        setTimeout(() => {
          this.deleteAlert = false;
        }, 2000);
      }
    },
    submitErrorAlert: function() {
      if (this.submitErrorAlert) {
        setTimeout(() => {
          this.submitErrorAlert = false;
        }, 10000);
      }
    },
  },
  methods: {
    setting: function() {
      let $this = this;
      if (this.template.typeLicense) this.license = this.template.typeLicense;
      if (this.opts) {
        for (let key in this.opts) {
          let prop = this.opts[key];
          if (prop.id.cvColumn === 'licenseDate') {
            $this.licenseDateFormat = prop.oFormat;
          }
        }
      }
      this.licenseMoreQuestionUseYn =
        this.template?.moreLicense == 'Y' ? 'Y' : 'N';
      if (this.licenseMoreQuestionUseYn == 'Y' && this.applNo) {
        this.fetchMoreLicense();
      }

      this.settingData();
      this.obj = this.defaultObj();
    },
    settingData: function() {
      if (this.info && this.info.licenses && this.info.licenses.length > 0) {
        this.itemSeq = this.info.licenses[0].id.seq;
        this.licenses = [];
        let $this = this;
        this.info.licenses.forEach(function(v) {
          var date = '';
          if (v.licenseDate && $this.licenseDateFormat === 'YYYY.MM.DD') {
            date =
              v.licenseDate.substring(0, 4) +
              '-' +
              v.licenseDate.substring(4, 6) +
              '-' +
              v.licenseDate.substring(6, 8);
          } else if (v.licenseDate && $this.licenseDateFormat === 'YYYY.MM') {
            date =
              v.licenseDate.substring(0, 4) +
              '-' +
              v.licenseDate.substring(4, 6);
          }

          $this.licenses.push({
            licenseName: v.licenseName,
            seq: v.id.seq,
            licenseNumber: v.licenseNumber,
            licenseOrg: v.licenseOrg,
            licenseDate: date,
            licenseDirectYn: v.licenseDirectYn,
            isFocused: false,
            datePicker: false,
          });

          $this.itemSeq =
            $this.itemSeq < v.id.seq ? v.id.seq + 1 : $this.itemSeq + 1;
        });
      }
    },
    defaultObj: function() {
      return {
        licenseName: '',
        seq: this.itemSeq++,
        licenseNumber: '',
        licenseOrg: '',
        licenseDate: '',

        licenseDirectYn: null,
        isFocused: false,
        datePicker: false,
      };
    },
    autocomset: function(i, item) {
      var tmp = i === -1 ? this.obj : this.licenses[i];

      if (item) {
        if (item.name !== tmp.licenseName) {
          tmp.licenseName = item.name;
          tmp.licenseOrg = item.hasOwnProperty('org') ? item.org : '';
        }

        if (item.hasOwnProperty('directYn')) {
          tmp.licenseDirectYn = item.directYn;
        } else {
          tmp.licenseDirectYn = 'N';
        }
      } else {
        tmp.licenseName = '';
        tmp.licenseOrg = '';
        tmp.licenseDirectYn = null;
      }

      tmp.isFocused = false;
      this.isSetWord = true;
      if (i !== -1) this.save(i);
    },
    setFocusEvent: function(i, focus) {
      if (this.isSetWord) {
        this.isSetWord = false;
        return;
      }
      var tmp = i === -1 ? this.obj : this.licenses[i];
      tmp.isFocused = focus;
    },
    add: function() {
      if (!this.canAdd)
        return this.$showAlert(
          '최대 입력 가능 갯수 : ' + `${this.opts.license.oMaxLength}`,
        );
      if (this.$refs.saveForm.validate()) {
        this.save(-1);
      }
    },
    async fetchMoreLicense() {
      const { data } = await API.getAuthJson('/cv/moreQuestions', {
        annoId: this.$route.params.annoId,
        applNo: this.applNo,
        cvColumn: 'moreLicense',
      });
      this.moreQuestions = data.answer;
      console.log('=====확인=====', this.moreQuestions);
    },
    async saveMoreLicense() {
      if (!this.moreQuestions || this.isReadonly) return;
      if (!this.$refs.moreLicense.validate()) return;
      try {
        await API.postAuthJson('/cv/moreQuestions', {
          id: {
            annoId: this.$route.params.annoId,
            applNo: this.applNo,
            cvColumn: 'moreLicense',
          },
          moreQuestions: this.moreQuestions ?? '',
        });
        snack.info(`${this.$(this.template.licenseTitle)}저장 되었습니다.`);
      } catch (error) {
        console.error(error);
      }
    },
    remove: function(i) {
      this.delete(i);
    },

    valid: function() {
      //필수 여부 체크
      if (
        this.opts &&
        this.opts.license &&
        this.opts.license.oRequireYn &&
        this.opts.license.oRequireYn == 'Y' &&
        this.licenses.length < 1
      ) {
        this.submitErrorMessage = this.$t(
          '최소 1개의 정보는 존재하여야 합니다.',
        );
        this.submitErrorAlert = true;
        return false;
      }

      //저장 폼에 자격증 명까지 입력을 한 뒤 저장을 안 누른 경우

      return this.$refs.updateForm.validate();
    },
    save: function(i) {
      var tmp = i === -1 ? this.obj : this.licenses[i];

      if (!this.$refs[i === -1 ? 'saveForm' : 'updateForm'].validate()) return;

      const id = {
        annoId: this.$route.params.annoId,
        seq: tmp.seq,
      };

      var pattern = /[^(가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9)]/gi; // 특수문자 제거
      const p = {
        id: id,
        licenseName: tmp.licenseName,
        licenseDate: tmp.licenseDate?.replace(pattern, '') || '',
        licenseNumber: tmp.licenseNumber,
        licenseOrg: tmp.licenseOrg,
        licenseDirectYn: tmp.licenseDirectYn,
      };

      this.$emit('save', p, 'license', i);
    },
    savecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('LICENSE SAVE FAIL');
      } else {
        snack.info(
          this.$t(this.template.licenseTitle) + this.$t(`이 저장 되었습니다.`),
        );
        if (i === -1) {
          this.licenses.push(this.obj);
          this.obj = this.defaultObj();
          this.$refs.saveForm.resetValidation();
        }
      }
    },
    delete: function(i) {
      const p = {
        annoId: this.$route.params.annoId,
        seq: this.licenses[i].seq,
      };
      this.$emit('delete', p, 'license', i);
    },
    deletecallback: function(res, i) {
      if (res.status !== 200) {
        console.log('LICENSE DELETE FAIL');
      } else {
        snack.danger(
          this.$t(this.template.licenseTitle) + this.$t(`이 삭제 되었습니다.`),
          this.licenses.splice(i, 1),
        );
      }
    },
  },
};
</script>

<style>
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.btn-post {
  position: absolute;
  top: 6px;
  right: 5px;
}
</style>
